import { render } from "./parrafos-template.vue?vue&type=template&id=3bb300da"
import script from "./parrafos-template.vue?vue&type=script&lang=js"
export * from "./parrafos-template.vue?vue&type=script&lang=js"

import "./parrafos-template.vue?vue&type=style&index=0&id=3bb300da&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__